import { Placeholder } from "react-bootstrap";
import { Box } from "../styled/Elements";
import styled from "styled-components";

const SkeletonContainer = styled(Box)`
  border-radius: 10px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .placeholder {
    background-color: #a7a7a7;
  }
`;

const InputSkeleton = styled.div`
  width: 100%;
  height: 30px;
  border-radius: 5px;
  background: #e0e0e0;
`;

const DataSkeleton = () => {
  return (
    <SkeletonContainer>
      <InputSkeleton />
      <InputSkeleton />
      <InputSkeleton />
      <InputSkeleton />
      <InputSkeleton />
      <InputSkeleton />
    </SkeletonContainer>
  );
};

export default DataSkeleton;
